import { Route, Routes } from 'react-router-dom';
import './App.css';
import HomePage from './components/HomePage/HomePage';
import ProductsPage from './components/ProductsPage/ProductsPage';
import ContactPage from './components/ContactPage/ContactPage';
import FloatingButtons from './components/FloatingButtons/FloatingButtons';
import ProductDetailPage from './components/ProductDetailPage/ProductDetailPage';

function App() {
  return (
    <>
      <Routes>
        <Route path='/' element={<HomePage />} />
               <Route path='/urunler' element={<ProductsPage />} />
<Route path="/iletisim" element={<ContactPage />} />
<Route path="/urunler/:id" element={<ProductDetailPage />} />
      </Routes>
<FloatingButtons />
    </>
  );
}

export default App;
